import React from "react";
import NavbarSindico from "../NavbarSindico/index";

import { PageContainer, Container } from "../styles";
import AcompanharSolicitacao from "../../../Components/Solicitacoes/AcompanharSolcitacao";
const AcompanharSolicitacaoSindico = () => {
  return (
    <PageContainer>
      <NavbarSindico />
      <Container>
        <AcompanharSolicitacao
          tiposSolicitacaoComAgendamento={["Assistência Técnica"]}
          isSindico
        />
      </Container>
    </PageContainer>
  );
};

export default AcompanharSolicitacaoSindico;
